<template>
    <Drawer :title="title" placement="right"
            :width="maxScreenWidth" :before-close="closeDrawerTicket"
            :value="value" @input="v => $emit('input', v)">
    <slot></slot>
    </Drawer>
</template>

<script>

export default {
    props:[
        'title',
        'value',
    ],
    methods:{
        // pergunta ao usuario se ele realmente quer fechar o componete sem salvar as alterações
        closeDrawerTicket() {
                return new Promise((resolve) => {
                    if (this.$parent.show_update) {
                        this.$Modal.confirm({
                            title: 'Há alterações que não foram salvas.',
                            content: 'Deseja realmente fechar?',
                            cancelText: "Não",
                            okText: "Sim",
                            onOk: () => {
                                this.$parent.show_update = false
                                this.$parent.action = null
                                resolve();
                            },
                        });
                    } else {
                        resolve();
                    }
                });
        },
    },
  computed: {
      maxScreenWidth() {
          return screen.width < 850 ? screen.width : 850;
      }
  }
}
</script>
